import React from 'react';
import PaymentSuccess from './PaymentSuccess';

/**
 * Payment Pending Page
 * Renders the PaymentSuccess component with pending status
 */
function PaymentPending({ onBackToLoans, token }) {
    return <PaymentSuccess onBackToLoans={onBackToLoans} forcedStatus="pending" token={token} />;
}

export default PaymentPending;
